export const contactTypes = Object.freeze({
  0: "Not Specified",
  1: "Email Address",
  2: "Telephone",
  3: "Fax",
  4: "Mobile",
});
